import React from 'react';
import { Link } from 'react-router';
import notifIcon from '../../../assets/images/notification.svg';
import notifActiveIcon from '../../../assets/images/notification-active.svg';
import { maskRedirectLink } from '../../../utils/utils';
import ToolTip from '../../ToolTip';
import { format } from 'date-fns';
import { notificationTemplate } from '../../../utils/notificationTemplate';
import { renderFlagSquareSmall } from '../../../utils/warehouseFlags';

const NotificationMenu = ({notification, readNotification, readAllNotification, isAuthenticated}) => {

  const handleClick = (id, data) => {
    const read = 1;
    readNotification(id,read);

    if (data && data.redirection_type === 'delivered') {
      window.open(
        `https://www.surveymonkey.com/r/shippingcart?account_number=${data.account_number}&tracking_number=${data.tracking_number}&date_delivered=${data.delivered_date}&origin_country=${data.origin}&shipment_method=${data.shipment_method}`,
        "_blank"
      );
    }
  }
  const handleNotifIcon = (data) => {
    if (data.redirection_type === "vas_payment_failed") {
      return 'icon-request-payment-canceled-rejected';
    }
    if (data.redirection_type === "vas_rejected") {
      return 'icon-request-status-canceled-rejected';
    }
    if (data.redirection_type === "vas_approved") {
      return 'vas-status-inprogress';
    }
    return data.icon;
  }

  const handleReadAll = () => {
    const read = 1;
    const id = notification ? notification[0].attributes.party_id : null;
    readAllNotification(id,read);
  }
  return (isAuthenticated && 
    <div className="notif-dropdown has-sub" style={{ display: 'flex', alignItems: 'center', }}>
      <img className="dropdown-toggle" data-toggle="dropdown" alt="icon" src={!!notification.length ? notifActiveIcon :notifIcon} style={{ paddingRight: 20, borderRight: '1px solid #E2E2E2' }} />
      <div className="sub sub-info dropdown-menu notification">
      <h3 className="notif-title">Notification{notification.length >= 2 ? "s" : null} &nbsp;&nbsp;
      {notification.length === 0 ? null : <span className="notif-count">{notification.length} new</span>}
      {notification.length === 0 ? null : <span className="notif-mark" role="button" onClick={() => {handleReadAll()}}>Mark all as read <span className="markasread icon-markasread" /> </span> }
      </h3>
      <div className="notif-body">
        <ul className='notif-ul'>
          {notification.length !== 0 ?
            notification.map(notif =>
              <li className="notif-list notif-link" key={notif.id} style={{ margin: 10 }}>
                <div direction="left" style={{ display: 'flex', justifyContent: 'flex-end' }}> 
                <Link
                  to={maskRedirectLink(JSON.parse(notif.attributes.data), notif.attributes.reference_id)}
                  style={{ display: 'flex', alignItems: 'center'}}
                  onClick={() => { 
                      handleClick(notif.id, JSON.parse(notif.attributes.data));
                    }}><div className="f-left" style={{marginRight: '10px'}}><span className={`notif-icon ${handleNotifIcon(JSON.parse(notif.attributes.data))}`}/></div>
                </Link>
                <Link
                  to={maskRedirectLink(JSON.parse(notif.attributes.data), notif.attributes.reference_id)}
                  style={{textDecoration: 'none'  }}
                  onClick={() => { 
                    handleClick(notif.id, JSON.parse(notif.attributes.data))
                    }}>
                <div direction="right" className="notif-details">
                      {JSON.parse(notif.attributes.data).warehouse && <span className="notif-tracking">
                        <img src={renderFlagSquareSmall(JSON.parse(notif.attributes.data).warehouse)} alt="warehouse" style={{ width: '29px', height: '27px', margin: '-1px 0px -4px -5px' }} />
                        {notificationTemplate(notif.attributes)}
                      </span>}
                      <span className='clamp-line vertical-box-orient '>{notif.attributes.template}</span>
                      <div className="notif-date">{format(notif.attributes.created_at, "MM/DD/YYYY hh:mma")}</div>
                    </div>
                </Link>
                    <div>
                      <ToolTip message={'Mark as read'} position={'top'}>
                        <i className="markasread icon-markasread"  aria-hidden="true" role="button" onClick={() => {
                          handleClick(notif.id, notif)}}></i>
                      </ToolTip>
                    </div>
                  </div> 
              </li>
            ):<li className="center empty"><span className="notif-empty icon-notif-empty"/><br/><h4 className="empty-msg">You have no notification</h4></li>
          }
        </ul>
      </div>
      <div className="see-all"><Link to="/notification">See all notifications</Link></div>
      </div>
    </div>
  )
}

export default NotificationMenu;


/** WEBPACK FOOTER **
 ** ./src/components/Layout/Header/NotificationMenu.js
 **/